import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { TeamMemberPaymentState } from "../../Slice/Dashboard/TeamMemberPaymentSlice";
import { getTeamMemberPaymentsAPI } from "../../ApiCalls/Dashboard/TeamMemberPaymentApi";
import {
  TeamMemberPayment,
  TeamMemberPaymentListResponse,
  TeamMemberPaymentsSummary,
} from "../../../Data/teamMemberPayment.dto";
import { showErrorToast } from "../../../components/atoms/Utlis/Toast";

/** API returns { data: { count, total_pages, current_page, page_size, team_member_payments?, results } } */
function getResultsFromPayload(
  payload: unknown
): {
  results: TeamMemberPayment[];
  count: number;
  total_pages: number;
  current_page: number;
  page_size: number;
  team_member_payments: TeamMemberPaymentsSummary | null;
} {
  if (Array.isArray(payload)) {
    return {
      results: payload,
      count: payload.length,
      total_pages: 1,
      current_page: 1,
      page_size: payload.length,
      team_member_payments: null,
    };
  }
  const data = (payload as { data?: TeamMemberPaymentListResponse })?.data;
  if (data) {
    return {
      results: data.results ?? [],
      count: data.count ?? 0,
      total_pages: data.total_pages ?? 0,
      current_page: data.current_page ?? 0,
      page_size: data.page_size ?? 15,
      team_member_payments: data.team_member_payments ?? null,
    };
  }
  const legacy = payload as { results?: TeamMemberPayment[] };
  const results = legacy?.results ?? [];
  return {
    results,
    count: results.length,
    total_pages: 1,
    current_page: 1,
    page_size: results.length,
    team_member_payments: null,
  };
}

export const TeamMemberPaymentReducer = (
  builder: ActionReducerMapBuilder<TeamMemberPaymentState>
) => {
  builder
    .addCase(getTeamMemberPaymentsAPI.pending, (state) => {
      state.loading = true;
      state.error = {};
    })
    .addCase(
      getTeamMemberPaymentsAPI.fulfilled,
      (state, action: PayloadAction<unknown>) => {
        state.loading = false;
        const { results, count, total_pages, current_page, page_size, team_member_payments } =
          getResultsFromPayload(action.payload);
        state.payments = results;
        state.team_member_payments = team_member_payments;
        state.count = count;
        state.total_pages = total_pages;
        state.current_page = current_page;
        state.page_size = page_size;
      }
    )
    .addCase(
      getTeamMemberPaymentsAPI.rejected,
      (state) => {
        state.loading = false;
        state.payments = [];
      }
    );
};
